"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useDraft = void 0;
var react_1 = __importDefault(require("react"));
var universal_emitter_1 = require("./universal-emitter");
function useDraft(chatUUID, _a) {
    var cache = _a.cache;
    var universalEmitter = (0, universal_emitter_1.useUniversalEmitter)();
    var _b = react_1["default"].useState(null), currentDraft = _b[0], setCurrentDraft = _b[1];
    react_1["default"].useEffect(function () {
        void cache.get("chat/drafts.".concat(chatUUID)).then(function (draft) {
            setCurrentDraft(draft !== null && draft !== void 0 ? draft : null);
        });
        universalEmitter.on("draft/updated/".concat(chatUUID), setCurrentDraft);
        return function () {
            universalEmitter.off("draft/updated/".concat(chatUUID), setCurrentDraft);
        };
    }, [chatUUID]);
    var updateDraft = react_1["default"].useCallback(function (draft) {
        void cache.set("chat/drafts.".concat(chatUUID), draft);
        void universalEmitter.emit("draft/updated/".concat(chatUUID), draft);
    }, [chatUUID]);
    return {
        currentDraft: currentDraft,
        updateDraft: updateDraft
    };
}
exports.useDraft = useDraft;
